import AccountTypesPage from './CreateAccountPage';

export default AccountTypesPage;
